import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addConfig, posterAll, getAll, disablePoster } from "@/api/Administration/advConfiguration";
import { getadvLocation } from "@/api/dataAll/advLocation";
import { serchSelect, serchSelectManage } from "@/mixins/index";
export default {
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      advchannels: [],
      advLocation: [],
      origin: [],
      dialogFormVisible: false,
      searchData: {
        id: "",
        origin: "",
        // 广告标识
        conf: {},
        game: "",
        channel: "",
        pkg: "",
        platform: "",
        ad_placement: "",
        ad_channel: "",
        special_product_id: ""
      },
      confValue: [],
      rules: {
        origin: [{
          required: true,
          message: this.$t('pleaseSelectAdMark'),
          trigger: "blur"
        }],
        game: [{
          required: true,
          message: this.$t('pleaseSelectGame'),
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: this.$t('pleaseSelectChannelMark'),
          trigger: "blur"
        }],
        pkg: [{
          required: true,
          message: this.$t('pleaseSelectDeliveryPackage'),
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: this.$t('pleaseSelectPlatform'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    posterAll().then(function (res) {
      _this.origin = res.data;
    });
  },
  methods: {
    removeDomain: function removeDomain(item) {
      var index = this.confValue.indexOf(item);

      if (index !== -1) {
        this.confValue.splice(index, 1);
      }
    },
    addDomain: function addDomain() {
      this.confValue.push({
        name: "",
        value: ""
      });
    },
    init: function init(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var conf, key;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (data) {
                  _this2.advChannelchange(data.ad_channel);

                  _this2.searchData = _objectSpread(_objectSpread({}, _this2.searchData), data);
                  _this2.searchData.id = data.ID;
                  conf = JSON.parse(data.conf);

                  for (key in conf) {
                    _this2.confValue.push({
                      name: key,
                      value: conf[key]
                    });
                  }
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.searchMark = {};
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        origin: "",
        conf: {},
        game: "",
        channel: "",
        pkg: "",
        platform: "",
        ad_placement: "",
        ad_channel: "",
        special_product_id: ""
      };
      this.searchplatforms = [];
      this.searchchannels = [];
      this.searchpkgs = [];
      this.confValue = [];
      this.$refs.ruleForm.resetFields();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = {};

          _this3.confValue.forEach(function (item, i) {
            data[item.name] = item.value;
          });

          _this3.searchData.conf = JSON.stringify(data);
          var req = _this3.searchData.id ? disablePoster : addConfig;
          req(_this3.searchData).then(function (res) {
            if (res.status == 1000) {
              Message.success(_this3.$t('operationSuccess'));

              _this3.$emit("refreshDataList");

              _this3.resetForm("ruleForm");
            }
          });
        }
      });
    }
  }
};